import { render, staticRenderFns } from "./lalmai-lakeland.vue?vue&type=template&id=72868d0e&scoped=true&"
import script from "./lalmai-lakeland.vue?vue&type=script&lang=js&"
export * from "./lalmai-lakeland.vue?vue&type=script&lang=js&"
import style0 from "./lalmai-lakeland.vue?vue&type=style&index=0&id=72868d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72868d0e",
  null
  
)

export default component.exports